import React from 'react';
import PropTypes from 'prop-types';

import { withStyles, withStylesPropTypes } from 'airbnb-dls-web/build/themes/withStyles';

import color from 'airbnb-dls-web/build/color';
import IconStar from 'airbnb-dls-web/build/exp/icons/IconStar';
import IconKitchen from 'airbnb-dls-web/build/exp/icons/IconKitchen';
import Spacing from 'airbnb-dls-web/build/exp/Spacing';
import Labeled from 'airbnb-dls-web/build/exp/Labeled';
import Text from 'airbnb-dls-web/build/exp/Text';

const propTypes = {
  ...withStylesPropTypes,
  stars: PropTypes.string.isRequired,
  forks: PropTypes.string.isRequired,
  sameLine: PropTypes.bool,
};

const defaultProps = {
  sameLine: false,
};

function StarsAndForks({ stars, forks, sameLine, justifyContent = 'flex-start' }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent,
      }}
    >
      <Spacing inline={sameLine}>
        <Labeled
          before={<IconStar color={color.starHighlightColor} decorative />}
          inline={sameLine}
        >
          <Text micro>{stars}</Text>
        </Labeled>
      </Spacing>
      {false && (
        <Labeled before={<IconKitchen decorative />} inline={sameLine}>
          <Text micro>{forks}</Text>
        </Labeled>
      )}
    </div>
  );
}

StarsAndForks.propTypes = propTypes;
StarsAndForks.defaultProps = defaultProps;

export default withStyles(() => ({
  inlineBlock: {
    display: 'inline-block',
  },
}))(StarsAndForks);



// WEBPACK FOOTER //
// ./src/components/StarsAndForks.jsx